export var AlertBannerType;

(function (AlertBannerType) {
  AlertBannerType["ATTENTION"] = "attention";
  AlertBannerType["CONFIRMATION"] = "confirmation";
  AlertBannerType["INFORMATION"] = "information";
  AlertBannerType["WARNING"] = "warning";
})(AlertBannerType || (AlertBannerType = {}));